import siteConfig from '../../site-config';

export default {
  data: () => ({
    ...siteConfig
  }),
  methods: {

  }
};